module.exports = __webpack_public_path__ + "img/60f3.2b76f2a2.jpg";